import { Switch } from 'antd';
import shallow from 'zustand/shallow';

import { useThemeStore } from '@/stores/useThemeStore';

export const ThemeButton = () => {
  const { theme, setTheme } = useThemeStore(
    (state) => ({ theme: state.theme, setTheme: state.setTheme }),
    shallow,
  );

  return (
    <Switch
      checked={theme === `dark`}
      onChange={(value) => setTheme(value ? `dark` : `light`)}
      checkedChildren="Dark"
      unCheckedChildren="Light"
    />
  );
};
